import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom' 
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import ApiContext from 'src/provider/API/call-service'
import { AppLabel, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, ScreenContainer } from 'src/style'
import { handleTypeNumberControl } from 'src/utils/utility'
import { IoArrowBackOutline } from 'react-icons/io5'
import helpers from 'src/utils/helpers'


export const BvnVerificationD2: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const {user: {onboardingInput}} = useContext(UserContext)
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)
    const [input, setInput] = useState({
        bvn: onboardingInput.bvn || '', 
        accountNumber: onboardingInput.accounNumber || '', 
        dateOfBirth: onboardingInput.dateOfBirth || '',
        email: onboardingInput.email || '',
        phoneNumberOrEmail: onboardingInput.phoneNumberOrEmail || ''
    })

    let isRfsFlow = info.institutionData.onboardingFlow === 'RFS'

    useEffect(() => {
        if (info.onboardingType) setOnboardingType(info.onboardingType)
    }, [info.onboardingType])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'bvn' && e.target.value.length > 11) return false
        if (e.target.name === 'accountNumber' && e.target.value.length > 17) return false
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        let response; 

        if (input.accountNumber.length > 17 && onboardingType === 'existing-user') return notifier.show('Kindly provide a valid account number', 'Validation Response')

        if (!isRfsFlow) {
            if (input.bvn.length != 11 || !input.bvn.startsWith('22')) return notifier.show('Kindly provide a valid bvn', 'Validation Response')

            let tcDate = await localStorage.getItem('@tcDate')!
            let formattedTcDate = new Date(tcDate)
            let tcSecs = (new Date().getTime() - formattedTcDate.getTime()) / 1000

            response = onboardingType === 'existing-user' ? 
                await API.validateReturningCustomerBvn(input) 
                : await API.validateNewCustomerBvn(input.bvn, input.dateOfBirth)
        }
        else {
            response = onboardingType === 'existing-user' ? 
            await API.validateNonNGReturningCustomer(input.accountNumber, input.phoneNumberOrEmail) 
            : await API.validateNonNGNewCustomer(input.email)
        }
        
        if (response) {
            if (response.isV1Customer) {
                navigate('/login')
            }
            else {
                setInfoProperty('onboardingProcessStatus', {...info.onboardingProcessStatus, isBvnVerified: true})
                navigate('/onboarding/phone_number-verification')
            }
        }
    }

    return (
        <>
            <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
                <FlexColumn 
                    justifyContent='flex-start'
                    className='onboarding-screen-container-d2'
                >
                    <AppText 
                        textSize='3' color='#101828' align='center' 
                        bottomMargin='1.5' fontFamily='Gilmer-Bold'
                    >
                        { isRfsFlow ? 'Verification' : 'Bank Verification Number' }
                    </AppText>
                    <AppSpan >Lets verify who you are</AppSpan>

                    <Form topMargin='3' onSubmit={handleSubmit}>
                        { !isRfsFlow ?
                            <>
                                <FormGroup>
                                    <label>BVN 11 Digits</label>
                                    <input 
                                        placeholder='Enter your BVN' 
                                        name='bvn'
                                        type='number'
                                        value={input.bvn}
                                        onChange={handleInput}
                                        onKeyDown={handleTypeNumberControl}
                                        onKeyUp={handleTypeNumberControl}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                { onboardingType === 'existing-user' &&
                                    <FormGroup>
                                        <label>Account Number</label>
                                        <input 
                                            placeholder='Enter your Account Number' 
                                            name='accountNumber'
                                            type='number'
                                            value={input.accountNumber}
                                            onChange={handleInput}
                                            onKeyDown={handleTypeNumberControl}
                                            onKeyUp={handleTypeNumberControl}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                }
                                <FormGroup>
                                    <label>Date of Birth</label>
                                    <input 
                                        placeholder='Enter your Date of Birth'
                                        name='dateOfBirth'
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.dateOfBirth ? '#000000' : '#667085'}}
                                        value={input.dateOfBirth}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                <CustomContainer 
                                    radius='0.8' borderColor='#E7F6F5' bgColor='#E7F6F5'
                                    padding='2' topPadding='1.5' topMargin='2.5'
                                >
                                    <AppLabel textSize='1.2' fontWeight='700' color='#0A756F'>Here’s why we need your BVN</AppLabel>
                                    <CustomContainer topMargin='1'>
                                        <AppText textSize='1.2' color='#0A756F' bottomMargin='1'>We need to verify you are who you say you are</AppText>
                                        <AppText textSize='1.2' color='#0A756F' bottomMargin='1'>We need to ensure we can profile accordingly</AppText>
                                        <AppText textSize='1.2' color='#0A756F'>We need your BVN to ensure we can protect you from fraudulent persons.</AppText>
                                    </CustomContainer>
                                </CustomContainer>
                            </>
                            :
                            <>
                                { onboardingType != 'existing-user' ?
                                    <FormGroup>
                                        <label>Email Address</label>
                                        <input 
                                            placeholder='Enter your Email Address' 
                                            name='email'
                                            type='email'
                                            value={input.email}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                    :
                                    <>
                                        <FormGroup>
                                            <label>Account Number</label>
                                            <input 
                                                placeholder='Enter your Account Number' 
                                                name='accountNumber'
                                                type='number'
                                                value={input.accountNumber}
                                                onChange={handleInput}
                                                onKeyDown={handleTypeNumberControl}
                                                onKeyUp={handleTypeNumberControl}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label>Phone Number or Email Address</label>
                                            <input 
                                                placeholder='Enter your Phone Number or Email Address' 
                                                name='phoneNumberOrEmail'
                                                type='text'
                                                value={input.phoneNumberOrEmail}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                    </>
                                }
                            </>
                        }
                        <FlexRow justifyContent='flex-end' gap='1.5' topMargin='2' >
                            <Button 
                                width='9.3' height='4' bgColor="#ffffff"
                                borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                childHoverColor='#0D968F' type="button"
                                onClick={() => navigate(-1)}
                            >
                                <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                    <IoArrowBackOutline/>
                                </AppSpan>
                                Back
                            </Button>
                            <Button 
                                width='8.8' height='4'
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </FlexColumn>
            </ScreenContainer>
            
        </>
    )
}
